import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { ChildFragmentFragment } from "@outschool/gql-frontend-generated";
import { useCallback } from "react";

export function useActiveLearnerSearchFilters(): typeof getSearchFilters {
  const getSearchFilters = useCallback(
    (activeLearner: ChildFragmentFragment | null): SearchFiltersType => {
      if (!activeLearner) {
        return {
          age: null,
          theme: null,
          format: null,
          capacityMin: null,
          capacityMax: null,
          startAfterTime: null,
          endByTime: null,
          dow: null,
        };
      }

      return {
        ...(activeLearner.age && { age: activeLearner.age.toString() }),
      };
    },
    [],
  );

  return getSearchFilters;
}
